import React from "react";
import { Hero } from "../components/home/Hero";
import { StorySection } from "../components/home/StorySection";
import { TimelineSection } from "../components/home/TimelineSection";
import { ProgrammeSection } from "../components/home/ProgrammeSection";
import { InvolvementSection } from "../components/home/InvolvementSection";
import { Footer } from "../components/Footer";
export function Home() {
  return <div className="min-h-screen w-full bg-cream" data-id="element-275" data-mp="1ziz6pd27kxvv">
      <Hero data-id="element-276" data-mp="1zka85686ltjt" />
      <main data-id="element-277" data-mp="24gsc43votnv3">
        <StorySection data-id="element-278" data-mp="24gio2lu7dqs1" />
        <TimelineSection data-id="element-279" data-mp="24htnyakj2edv" />
        <ProgrammeSection data-id="element-280" data-mp="24j4rc9a29k4g" />
        <InvolvementSection data-id="element-281" data-mp="29gdbugiom08v" />
      </main>
      <Footer data-id="element-282" data-mp="29fc0eaxr7bqm" />
    </div>;
}